export const DEMO_CUSTOMER = {
  orgName: "Harbor Trust Bank, N.A.",
  shortName: "Harbor Trust",
  emailDomain: "harbortrust.com",
  tenantSlug: "harbor-trust",
  walletPrefix: "HT",
} as const;
